import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

export const ShoppingBag = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      stroke={props.color || theme.palette.grey600}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.0853 9.3335H7.91463C7.21197 9.3335 6.63063 9.8775 6.58397 10.5775L5.52263 26.4895C5.41997 28.0282 6.6413 29.3335 8.18397 29.3335H23.816C25.3586 29.3335 26.58 28.0282 26.4773 26.4895L25.416 10.5775C25.3693 9.8775 24.788 9.3335 24.0853 9.3335Z"
      />
      <path d="M20.0013 11.9998V6.6665V6.6665V6.6665C20.0013 4.45717 18.2107 2.6665 16.0013 2.6665H16C13.7907 2.6665 12 4.45717 12 6.6665V6.6665V6.6665V11.9998" />
    </svg>
  );
};
